import React from 'react';
import InspectorCard from './inspector_card';
import StudentCohortIconList from './student_cohort_icon_list';
import StudentCohortDetails from './student_cohort_details';
import StudentCohortFilters from './student_cohort_filters';


export default function StudentCohorts(props) {
  return (
    <InspectorCard header="Students" {...props} className="abl-student-cohorts">
      
      <StudentCohortDetails {...props} />
      <StudentCohortIconList items={props.filteredStudents} ratio={props.studentRatio} />
      <StudentCohortFilters items={props.filters} onChange={props.onFilterChange} />
    </InspectorCard>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule_inspector/student_cohorts.js
 **/